import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  position: {
    default: 'A useful bit of information',
    editor: 'dropdown',
    editorOptions: ['', 'bottom-left', 'bottom-right', 'top-left', 'top-right'],
  },
};
const PlaygroundV3Knobs: Knobs = {
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'Playground where you can render alerts in any corner of the screen',
  coreComponent: {
    html: `<tag-toast{{...knobs}}>
  <tag-alert
    type='danger'
    text='Something went a bit wrong!'
    show-duration='5000'
    alert-type='toast'
    closeable>
  </tag-alert>
  <tag-alert
    type='warning'
    text='Something nearly went a bit wrong!'
    show-duration='4000'
    alert-type='toast'
    closeable>
  </tag-alert>
  <tag-alert
    type='information'
    text='Something went well!'
    show-duration='3000'
    alert-type='toast'
    closeable>
  </tag-alert>
</tag-toast>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-toast{{...knobs}}>
  <tag3-alert
    type='danger'
    text='Something went a bit wrong!'
    show-duration='5000'
    alert-type='toast'
    closeable>
  </tag3-alert>
  <tag3-alert
    type='warning'
    text='Something nearly went a bit wrong!'
    show-duration='4000'
    alert-type='toast'
    closeable>
  </tag3-alert>
  <tag3-alert
    type='information'
    text='Something went well!'
    show-duration='3000'
    alert-type='toast'
    closeable>
  </tag3-alert>
</tag3-toast>`,
    knobs: { ...PlaygroundKnobs, ...PlaygroundV3Knobs },
  },
  reactWrapper: {
    jsx: `<TagToast{{...knobs}}>
  <TagAlert
    type='danger'
    text='Something went a bit wrong!'
    showDuration='5000'
    alertType='toast'
    closeable>
  </TagAlert>
  <TagAlert
    type='warning'
    text='Something nearly went a bit wrong!'
    showDuration='4000'
    alertType='toast'
    closeable>
  </TagAlert>
  <TagAlert
    type='information'
    text='Something went well!'
    showDuration='3000'
    alertType='toast'
    closeable>
  </TagAlert>
</TagToast>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Toast{{...knobs}}>
  <Tag3Alert
    type='danger'
    text='Something went a bit wrong!'
    showDuration='5000'
    alertType='toast'
    closeable>
  </Tag3Alert>
  <Tag3Alert
    type='warning'
    text='Something nearly went a bit wrong!'
    showDuration='4000'
    alertType='toast'
    closeable>
  </Tag3Alert>
  <Tag3Alert
    type='information'
    text='Something went well!'
    showDuration='3000'
    alertType='toast'
    closeable>
  </Tag3Alert>
</Tag3Toast>`,
    knobs: { ...PlaygroundKnobs, ...PlaygroundV3Knobs },
  },
};
export const TagToastDocs: Component = {
  type: 'component',
  name: 'toast',
  description: 'Renders a container for alerts that can be shown in the corners of the screen',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'position',
      description: 'The position to display the toast',
      type: 'bottom-left | bottom-right | top-left | top-right',
      default: 'bottom-right',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
